module.exports = __webpack_public_path__ + "img/gonetworksj3.c15a6b30.png";